import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, OutlinedComponent, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { getUprights } from "../utils/sectionsHelpers";
export default class SectionSelectionSystem extends SystemBase {
    constructor(core) {
        super(ComponentIds.SELECTED_COMPONENT_ID);
        this.core = core;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "SectionSelectionSystem";
        this.mandatoryComponents = [COMPONENT_IDS.MOUNTING_RAIL_COMPONENT];
    }
    onAddComponent(_entity, _newComponent) {
        super.onRemoveComponent(_entity, _newComponent);
        const { leftUpright, rightUpright } = getUprights(_entity);
        leftUpright === null || leftUpright === void 0 ? void 0 : leftUpright.addComponent(new OutlinedComponent());
        rightUpright === null || rightUpright === void 0 ? void 0 : rightUpright.addComponent(new OutlinedComponent());
    }
    onRemoveComponent(_entity, _oldComponent) {
        super.onRemoveComponent(_entity, _oldComponent);
        const { leftUpright, rightUpright } = getUprights(_entity);
        leftUpright === null || leftUpright === void 0 ? void 0 : leftUpright.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
        rightUpright === null || rightUpright === void 0 ? void 0 : rightUpright.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
    }
}
